import React, { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';
import { injected, bscConnector, shortenAddress, switchToBscTestnet } from '../utils/wallet';
import { bscTestnetChainId } from '../contracts/contractABI';

const WalletConnect = () => {
  const { active, account, activate, deactivate, library, chainId } = useWeb3React();
  const [connecting, setConnecting] = useState(false);
  const [networkError, setNetworkError] = useState(false);

  // Check if connected to the correct network
  useEffect(() => {
    if (active && chainId !== bscTestnetChainId) {
      setNetworkError(true);
    } else {
      setNetworkError(false);
    }
  }, [active, chainId]);

  // Connect to MetaMask
  const connectMetaMask = async () => {
    setConnecting(true);
    try {
      await activate(injected);
    } catch (error) {
      console.error('Error connecting to MetaMask:', error);
    } finally {
      setConnecting(false);
    }
  };

  // Connect to Binance Chain Wallet
  const connectBinanceWallet = async () => {
    setConnecting(true);
    try {
      await activate(bscConnector);
    } catch (error) {
      console.error('Error connecting to Binance Chain Wallet:', error);
    } finally {
      setConnecting(false);
    }
  };

  // Disconnect wallet
  const disconnectWallet = () => {
    try {
      deactivate();
    } catch (error) {
      console.error('Error disconnecting wallet:', error);
    }
  };

  // Switch to BSC Testnet
  const handleSwitchNetwork = async () => {
    if (!library) return;
    
    const success = await switchToBscTestnet(library);
    if (success) {
      setNetworkError(false);
    }
  };

  return (
    <div className="wallet-connect">
      <h2>Wallet Connection</h2>
      
      {!active ? (
        <div className="connect-buttons">
          <button 
            onClick={connectMetaMask} 
            disabled={connecting}
            className="connect-button"
          >
            {connecting ? 'Connecting...' : 'Connect MetaMask'}
          </button>
          
          <button 
            onClick={connectBinanceWallet} 
            disabled={connecting}
            className="connect-button"
          >
            {connecting ? 'Connecting...' : 'Connect Binance Wallet'}
          </button>
        </div>
      ) : (
        <div className="wallet-info">
          <p>
            <strong>Connected Account:</strong> {shortenAddress(account)}
          </p>
          
          {networkError ? (
            <div className="network-error">
              <p className="error-message">
                You are not connected to BSC Testnet. Please switch your network.
              </p>
              <button onClick={handleSwitchNetwork} className="switch-network-button">
                Switch to BSC Testnet
              </button>
            </div>
          ) : (
            <p className="network-success">Connected to BSC Testnet</p>
          )}
          
          <button onClick={disconnectWallet} className="disconnect-button">
            Disconnect Wallet
          </button>
        </div>
      )}
    </div>
  );
};

export default WalletConnect;
